/**
 * FIN-659: human label for a provider-reported ISO 20022 cash account type. `CACC` (an
 * ordinary business current account) and `null` (nothing reported, or an unrecognised value)
 * both return `null` -- the badge exists to flag an account that ISN'T the default-looking
 * current account, not to relabel the common case. See ExternalCashAccountType1Code.
 */
const CASH_ACCOUNT_TYPE_LABELS = {
  SVGS: 'Savings',
  CARD: 'Card account',
  CASH: 'Cash account',
  LOAN: 'Loan account',
  OTHR: 'Other',
} as const;

export type LabelledCashAccountType = keyof typeof CASH_ACCOUNT_TYPE_LABELS;

/** The type code when it is one the badge words, else `null`; the screen words it in its own language. */
export function cashAccountTypeCode(cashAccountType: string | null | undefined): LabelledCashAccountType | null {
  return cashAccountType && Object.keys(CASH_ACCOUNT_TYPE_LABELS).includes(cashAccountType)
    ? (cashAccountType as LabelledCashAccountType)
    : null;
}

export function cashAccountTypeLabel(cashAccountType: string | null | undefined): string | null {
  const code = cashAccountTypeCode(cashAccountType);
  return code ? CASH_ACCOUNT_TYPE_LABELS[code] : null;
}
